import React, { useState } from 'react';
import * as R from 'ramda';
import { StyledTableWrapper, getUpdateDiv, tableRender } from './common';
import { useFormalGameDispatch, useFormalGameState } from './useFormalGame';
import Button from '~~elements/Button';

export const columns = [
  {
    column: 'PASeq',
    label: '流水號',
    className: 'first',
  },
  {
    column: 'event_seq',
    label: '事件順序',
  },
  {
    column: 'runner_seq',
    label: '跑壘順序',
  },
  {
    column: 'runner.name',
    label: '跑者',
  },
  {
    column: 'code',
    label: '跑壘型態',
  },
  {
    column: 'start_base',
    label: '開始壘包',
  },
  {
    column: 'end_base',
    label: '結束壘包',
    updatable: Number,
  },
  {
    column: 'is_out',
    label: '是出局',
    updatable: Boolean,
  },
  {
    column: 'is_scoring',
    label: '是得分',
    updatable: Boolean,
  },
  {
    column: 'is_RBI',
    label: '是打點',
    updatable: Boolean,
  },
  {
    column: 'is_ER',
    label: '是責失',
    updatable: Boolean,
  },
  {
    column: 'count_on_pitcher.name',
    label: '失分投手',
    updatable: 'Pitcher',
  },
];

export const toRunnerList = (PAList) => {
  return R.flatten(
    PAList.map((PA, PAIndex) => {
      return PA.runners.map((runner, runnerIndex) => ({
        batter: PA.batter,
        pitcher: PA.pitcher,
        inning: PA.inning,
        PA_round: PA.PA_round,
        PA_order: PA.PA_order,
        PASeq: PAIndex + 1,
        event_seq: runner.event_index + 1,
        runner_seq: runnerIndex + 1,
        ...runner,
      }));
    }),
  );
};

const FormalGameRunners = ({ players, opponentPlayers, PAList, handleUpdate, handleRowSave }) => {
  const [selectedRow, setSelectedRow] = useState(-1);
  const [selectColumn, setSelectColumn] = useState('');
  const { statsUpdateRows } = useFormalGameState();
  const formalGameDispatch = useFormalGameDispatch();

  const runnerList = toRunnerList(PAList);

  return (
    <div>
      {Object.keys(statsUpdateRows).length > 0 && (
        <section className="update-pending-list">
          <p>
            待更新清單
            <Button mini color="red" width="auto" onClick={() => handleUpdate()}>
              確認更新
            </Button>
          </p>
          <ul>
            {Object.keys(statsUpdateRows).map((rowIndex) =>
              statsUpdateRows[rowIndex].map((toUpdate, columnIndex) => (
                <li
                  key={`${runnerList[rowIndex].inning}-${runnerList[rowIndex].PA_order}-${runnerList[rowIndex].PA_round}`}
                >
                  <p>
                    <Button
                      className="cancel-update"
                      mini
                      color="blue"
                      onClick={() =>
                        formalGameDispatch({ type: 'REMOVE_STATS_UPDATE_ROW', payload: { rowIndex, columnIndex } })
                      }
                    >
                      x
                    </Button>
                    {`${runnerList[rowIndex].inning}局 ${runnerList[rowIndex].PA_order}棒 ${runnerList[rowIndex].runner.name}: `}
                    {`${toUpdate.toUpdateColumn} -> ${JSON.stringify(toUpdate.newValue)}`}
                  </p>
                </li>
              )),
            )}
          </ul>
        </section>
      )}
      {getUpdateDiv(
        runnerList,
        columns,
        setSelectedRow,
        setSelectColumn,
        selectedRow,
        selectColumn,
        Object.keys(statsUpdateRows).length === 0 ? handleUpdate : null,
        {
          pitchers: opponentPlayers,
          handleRowSave,
        },
      )}
      <StyledTableWrapper>
        {tableRender(runnerList, columns, setSelectedRow, setSelectColumn, selectedRow, selectColumn)}
      </StyledTableWrapper>
    </div>
  );
};

export default FormalGameRunners;
